<template>
    <div class="catalog-second-section__wrapper">
        <a
            v-for="item in list"
            :key="item.id"
            class="card-product"
            :class="[
                { 'dark-background': !item.preview_light },
                item.preview_position_top ? 'card-product_top-left' : 'card-product_bottom-left'
            ]"
            :href="
                `${lang_prefix}/${item.category.parent.slug}/${item.category.slug}/${item.slug}/`
            "
            :style="{
                backgroundImage: item.media.length
                    ? `url(/storage/${item.media[0].id}/${item.media[0].file_name})`
                    : 'url(/assets/img/catalog-1.png)'
            }"
        >
            <favorite-button :id="item.id"></favorite-button>
            <div class="card-product__info">
                <p class="card-product__info-text">{{ $lang(item.title) }}</p>
                <span class="card-product__info-price" v-if="item.price"
                    >{{ Math.round(item.price) }} UAH</span
                >
                <div
                    class="card-product__info-list"
                    v-html="$lang(item.short_equipment)"
                ></div>
                <div
                    class="card-product__info-description"
                    v-html="$lang(item.short_equipment)"
                ></div>
            </div>
        </a>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "CatalogItem",
    computed: {
        ...mapGetters("catalog", ["list"]),
        lang_prefix() {
            return this.$currentLang === "ru" ? "/ru" : '';
        }
    }
};
</script>

<style scoped></style>
